'use client';

import { motion } from 'motion/react';
import { useInView } from 'react-intersection-observer';

export interface SlidingTextProps {
	className?: string;
	text: string;
}

export default function SlidingText({ className, text }: SlidingTextProps) {
	const { ref, inView } = useInView({ delay: 500, triggerOnce: true });

	return (
		<div ref={ref}>
			{inView && (
				<motion.div
					variants={{
						hidden: { opacity: 0 },
						visible(i = 1) {
							return {
								opacity: 1,
								transition: {
									staggerChildren: 0.1,
									delayChildren: 0.1 * i,
								},
							};
						},
					}}
					initial="hidden"
					animate="visible"
					style={{ display: 'flex', overflow: 'hidden' }}
				>
					{text.split('').map((letter, index) => (
						<motion.span
							key={index}
							variants={{
								hidden: { y: 50, opacity: 0 },
								visible: { y: 0, opacity: 1, transition: { duration: 0.5 } },
							}}
							style={{
								display: 'inline-block',
							}}
						>
							<span className={className}>{letter}</span>
						</motion.span>
					))}
				</motion.div>
			)}
		</div>
	);
}
